import {type ImgHTMLAttributes} from "react"
import {useMantineTheme} from "@mantine/core"
// eslint-disable-next-line @nx/enforce-module-boundaries -- The icon rules moved to the shared Tailwind library.
import {
  type ContainerStatusIconName,
  containerStatusIconLabels,
  type ContainerStatusIconSet,
  type ContainerStatusIconVariant,
  getContainerStatusIconSrc,
  useContainerStatusIconSet,
} from "@ots-frontend/ots-ui-tw"

// The names, labels, file paths and the rules for which icons apply live in ots-ui-tw (container-status-icons);
// re-exported here so existing imports keep working.
// eslint-disable-next-line @nx/enforce-module-boundaries -- The icon rules moved to the shared Tailwind library.
export {
  containerStatusIconNames,
  containerStatusIconLabels,
  defaultContainerStatusIconSet,
  ContainerStatusIconSetProvider,
  useContainerStatusIconSet,
  getContainerStatusIconSrc,
  resolveContainerStatusIcons,
} from "@ots-frontend/ots-ui-tw"
// eslint-disable-next-line @nx/enforce-module-boundaries -- The icon rules moved to the shared Tailwind library.
export type {
  ContainerStatusIconName,
  ContainerStatusIconVariant,
  ContainerStatusIconSet,
  ContainerStatusIconDescriptor,
} from "@ots-frontend/ots-ui-tw"

export type ContainerStatusIconProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "alt" | "src"> & {
  name: ContainerStatusIconName
  variant?: ContainerStatusIconVariant
  /** Overrides the set from ContainerStatusIconSetProvider. */
  iconSet?: ContainerStatusIconSet
  /** Overrides Mantine's scheme, for hosts themed by OtsThemeRoot. */
  colorScheme?: "light" | "dark"
  alt?: string
}

export const ContainerStatusIcon = ({
  name,
  variant = "filled",
  iconSet,
  colorScheme: colorSchemeProp,
  alt = containerStatusIconLabels[name],
  width = 24,
  height = 24,
  ...rest
}: ContainerStatusIconProps) => {
  const contextSet = useContainerStatusIconSet()
  const {colorScheme} = useMantineTheme()
  return (
    <img
      {...rest}
      alt={alt}
      src={getContainerStatusIconSrc(name, variant, iconSet ?? contextSet, colorSchemeProp ?? colorScheme)}
      width={width}
      height={height}
    />
  )
}
